import './styles/AlertsByHost.css'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import data_ubi from './ubicaciones'
import { useFetch } from '../hooks/useFetch'
import RowProblem from './RowProblem'
import LoadAlerts from './LoadAlerts'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from './generales/traduction'
const AlertsByHost=({dataCriticalities,dataAgencies,handleShowPopup,languaje,mode,hostId,userPermissions ,mapAux,ubiActual,setmapAux,server,search_problems,suveryId,setSuveryId,setImportModalOpen})=>{
  // const alerts_list=useFetch('zabbix/hosts/detail/alerts',hostId,'','GET',server)
  // const dataAgencies=useFetch('cassia/exception_agencies','','props.token','GET',server)
  const [orderAsc, setOrderAsc] = useState(true)
  const [problems, setProblems] = useState([])
  const [dataProblems, setDataProblems] = useState({ data: [], loading: true, error: null })
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])

  useEffect(() => {
    search_problems()
  }, [hostId])

  function search_problems() {
    setDataProblems({ data: dataProblems.data, loading: true, error: dataProblems.error })
    const fetchData = async () => {
      try {
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/detail/alerts/' + hostId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          setProblems(response_data.data)
          setDataProblems({ data: response_data.data, loading: false, error: dataProblems.error })
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setDataProblems({ data: dataProblems.data, loading: false, error: error })
      }
    };
    fetchData();
  }

  const formatDateTime = (dateTimeString) => {
    const [datePart, timePart] = dateTimeString.split(' ');
    const [day, month, year] = datePart.split('/');
    return `${year}/${month}/${day} ${timePart}`;
  };

  const orderBy = (attr) => {
    if (!problems || problems.length === 0) return;
    const sortedData = [...problems].sort((a, b) => {
      if (orderAsc) {
        setOrderAsc(false)
        if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return 1;
        if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return -1;
      } else {
        setOrderAsc(true)
        if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return 1;
        if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return -1;
      }
      return 0;
    });
    setProblems(sortedData);
  };

  return (
    <div className='ev-table-wrap' style={{ height: '300px' }}>
      <table className="ev-table">
        <thead className="ev-table-thead">
          <tr>
            <th style={{ width: '40px' }}>
              <input type="checkbox" disabled />
            </th>
            <th>SEV.</th>
            <th>INCIDENCIA</th>
            <th>DISPOSITIVO</th>
            <th>ESTATUS</th>
            <th>ODD</th>
            <th>DDT</th>
            <th>ACK</th>
            <th>TICKET</th>
            <th>SLA</th>
            <th>T. ACTUAL</th>
            <th onClick={() => orderBy('Time')} style={{ cursor: 'pointer' }}>
              FECHA {orderAsc ? '↑' : '↓'}
            </th>
            <th>HORA</th>
          </tr>
        </thead>
        <tbody className="ev-table-tbody">
          {dataProblems.loading ? (
            <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px' }}><LoadAlerts languaje={languaje} /></td></tr>
          ) : problems.length === 0 ? (
            <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px', color: '#9ca3af' }}>Sin alertas</td></tr>
          ) : (
            problems.map((elemento, indice) => (
              <RowProblem
                key={indice}
                dataCriticalities={dataCriticalities}
                languaje={languaje}
                setImportModalOpen={setImportModalOpen}
                setSuveryId={setSuveryId}
                handleShowPopup={handleShowPopup}
                mode={mode}
                userPermissions={userPermissions}
                ubiActual={ubiActual}
                mapAux={mapAux}
                setmapAux={setmapAux}
                search_problems={search_problems}
                severity={elemento.severity}
                dataAgencies={dataAgencies}
                data={elemento}
                server={server}
                poolRows={poolRows}
                setPoolRows={setPoolRows}
                poolObjectRows={poolObjectRows}
                setPoolObjectRows={setPoolObjectRows}
                filtraOrigen={false}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AlertsByHost